module.exports = __webpack_public_path__ + "img/stockpickinglab_hint.521ecf6f.png";